import { Box } from '@vk-hr-tek/ui/Box';
import { EllipsisText } from '@vk-hr-tek/ui/EllipsisText';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Tooltip } from '@vk-hr-tek/ui/Tooltip';
import { IconButton } from '@vk-hr-tek/ui/IconButton';
import { Icon as ImportedIcon } from '@vk-hr-tek/ui/Icon';

interface NotificationItemBodyProps {
  variant: 'list' | 'plugin';
  message: string;
  read: boolean;
  onRead: () => void;
  onTooltipOpen: () => void;
  onTooltipClose: () => void;
}

export const NotificationItemBody = ({
  variant,
  message,
  read,
  onRead,
  onTooltipOpen,
  onTooltipClose,
}: NotificationItemBodyProps) => {
  const isPlugin = variant === 'plugin';

  return (
    <Box
      display="flex"
      alignItems="start"
      justifyContent="space-between"
      gap="4"
    >
      {isPlugin ? (
        <EllipsisText wordBreak="break-word">
          <Typography variant="body3">{message}</Typography>
        </EllipsisText>
      ) : (
        <Typography variant="body3" wordBreak="break-word">
          {message}
        </Typography>
      )}
      <Tooltip
        placement="bottom"
        title="Отметить прочитанным"
        disabled={read}
        onOpen={onTooltipOpen}
        onClose={onTooltipClose}
      >
        <Box display="flex" {...(read && { visibility: 'hidden' })}>
          <IconButton
            size="medium"
            disableRipple
            onClick={onRead}
            testId="test-id-mark-notification-read"
          >
            <Box m="-8">
              <ImportedIcon
                name="circle_small_filled"
                size="24"
                color="accent.text.error"
              />
            </Box>
          </IconButton>
        </Box>
      </Tooltip>
    </Box>
  );
};
